import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, fromEvent, debounceTime, takeUntil } from 'rxjs';

@Directive({
  selector: '[dynamicPagination]',
  standalone: true
})
export class DynamicPaginationDirective implements OnInit, OnDestroy {
  @Input() rowHeight = 32; // Default row height
  @Input() offsetHeight = 200; // Default offset for header, footer, etc.
  @Input() paginationInstance: any; // Reference to pagination instance
  @Input() extraItemsPerPage = 0; // Extra items per page
  
  private destroy$ = new Subject<void>();
  private resizeObserver: ResizeObserver;

  constructor(private el: ElementRef) {
    // Initialize ResizeObserver
    this.resizeObserver = new ResizeObserver(() => {
      this.calculateItemsPerPage();
    });
  }

  ngOnInit() {
    // Start observing the table element
    this.resizeObserver.observe(this.el.nativeElement);

    // Listen for window resize events
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(150),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.calculateItemsPerPage();
      });

    // Initial calculation
    this.calculateItemsPerPage();
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private calculateItemsPerPage() {
    // const tableContainer = this.el.nativeElement;
    const availableHeight = window.innerHeight - this.offsetHeight;
    const itemsPerPage = Math.max(1, Math.floor(availableHeight / this.rowHeight));

    // Update the pagination instance
    if (this.paginationInstance) {
      this.paginationInstance.itemsPerPage = itemsPerPage + this.extraItemsPerPage;
    }
  }
}
